export default __webpack_public_path__ + "static/2155-fb6c78dd04f0fad30158f38d2be9231c.gif";